import {AppBox, AppContainer, AppPaginator} from "../../../commons/components";
import {useEffect} from "react";
import {useAppDispatch, useAppSelector} from "../../../hooks/app";
import {Outlet, useParams} from "react-router";
import {cleanUpStadiumList, fetchManageStadiumList} from "../../../redux/slices/stadium/manage-stadium-list-slice";
import StadiumList from "./components/StadiumList";
import {setPageTitle} from "../../../redux/slices/page-title-slice";

import usePagination from "../../../hooks/usePagination";
import useFilter from "../../../hooks/useFilter";

export default function StadiumManage() {
    const dispatch = useAppDispatch();
    const {stadiumId} = useParams();
    const {stadiumList} = useAppSelector((state) => state.manageStadiumList);
    const {page, perPage, pageChange, pageLimitChange} = usePagination();
    const {searchText, sortOrder, sortBy} = useFilter();

    useEffect(() => {
        dispatch(setPageTitle("Venues"));
    }, []);

    useEffect(() => {
        dispatch(fetchManageStadiumList({sort: sortBy, sortOrder, name: searchText, page, perPage}));
    }, [page, perPage, searchText, sortBy, sortOrder]);

    useEffect(() => {
        return () => {
            dispatch(cleanUpStadiumList());
        };
    }, []);

    return (
        <>
            {stadiumId ? (
                <Outlet/>
            ) : (
                <AppContainer>
                    <AppBox py="md" flexDirection="column" gap="md">
                        <StadiumList/>
                        {stadiumList?.pageCount > 1 &&
                            <AppPaginator
                                perPage={stadiumList.perPage}
                                pageCount={stadiumList.pageCount}
                                currentPage={stadiumList.page}
                                pageChange={pageChange}
                                perPageLimitChange={pageLimitChange}/>
                        }
                    </AppBox>
                </AppContainer>
            )}
        </>
    );
}
